<div>
  <mat-chip-listbox>
    <mat-chip [attr.status]="request.requestStatus"> {{ request.date | date: 'dd/MM/YYYY' }} </mat-chip>
  </mat-chip-listbox>
</div>
